import { render, staticRenderFns } from "./new-bucket-folder.html?vue&type=template&id=20fefd9a&scoped=true&"
import script from "./new-bucket-folder.js?vue&type=script&lang=js&"
export * from "./new-bucket-folder.js?vue&type=script&lang=js&"
import style0 from "./new-bucket-folder.scss?vue&type=style&index=0&id=20fefd9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fefd9a",
  null
  
)

export default component.exports